import { format, setDefaultOptions } from 'date-fns'
import { ptBR } from 'date-fns/locale'

setDefaultOptions({
  locale: ptBR,
})

export function formatDate(date, pattern = 'dd/MM/yyyy') {
  if (!date) {
    return
  }

  const dateFormatted = format(new Date(date), pattern)

  return dateFormatted
}
